import { theme } from '../theme';

export const ToteStatus = {
  open: 'open',
  shipped: 'shipped',
  ready_to_pack: 'ready_to_pack',
  in_progress: 'in_progress',
};

export const ToteStatusColors = {
  [ToteStatus.open]: theme.colors.green,
  [ToteStatus.shipped]: theme.colors.primary,
  [ToteStatus.ready_to_pack]: theme.colors.darkBlue,
  [ToteStatus.in_progress]: theme.colors.orange,
};

export const PalletStatus = {
  available: 'available',
  reserved: 'reserved',
  in_transit: 'in_transit',
  in_use: 'in_use',
};

export const PalletStatusColors = {
  [PalletStatus.available]: theme.colors.green,
  [PalletStatus.reserved]: theme.colors.primary,
  [PalletStatus.in_transit]: theme.colors.darkBlue,
  [PalletStatus.in_use]: theme.colors.orange,
};

export const packagingMaterialTypes = [
  {
    text: 'Box',
    value: 'Box',
    key: 'Box',
  },
  {
    text: 'Envelope',
    value: 'Envelope',
    key: 'Envelope',
  },
  {
    text: 'Bag',
    value: 'Bag',
    key: 'Bag',
  },
  {
    text: 'Tube',
    value: 'Tube',
    key: 'Tube',
  },
  {
    text: 'Custom',
    value: 'Custom',
    key: 'Custom',
  },
];
